import {createStyles, Stack, Box, Typography} from "@mui/material";
import AssetsTransItem from "./AssetsTransItem.tsx";
import {useEffect} from "react";
import dayjs from "dayjs";
import {useNavigate} from "react-router-dom";

interface Props {
  dateText: string;
  list: any[],
  onClick: (item: any) => void;
}

const DayAssetsTransItem = (props: Props) => {

  const {dateText, list, onClick} = props;

  return (<>
    <Box>
      <Stack sx={{padding: '16px'}}>
        <Box sx={(theme) => {

        }}>
          <Typography>{dayjs(dateText).format('dddd, MMMM d')}</Typography>
        </Box>
        {
          list.map((item) => (
            <Box
              key={dateText}
              onClick={() => {

                onClick && onClick(item);
              }}
            >
              <AssetsTransItem record={item} key={dateText}/>
            </Box>

          ))
        }
      </Stack>
    </Box>
  </>)
}

export default DayAssetsTransItem